import { render, staticRenderFns } from "./road_toll_settle.vue?vue&type=template&id=226aba84&scoped=true&"
import script from "./road_toll_settle.vue?vue&type=script&lang=js&"
export * from "./road_toll_settle.vue?vue&type=script&lang=js&"
import style0 from "./road_toll_settle.vue?vue&type=style&index=0&id=226aba84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226aba84",
  null
  
)

export default component.exports